import axios from "../api";
import { CRYPTO_TOKEN_SECRET_KEY } from "../config";
import CryptoJS from "crypto-js";


const getAuthToken = () => {
  const decryptedData = CryptoJS.AES.decrypt(
    localStorage.getItem("token"),
    CRYPTO_TOKEN_SECRET_KEY
  ).toString(CryptoJS.enc.Utf8);

  return decryptedData;
};

export const getMailLogsAction = async (
  page,
  pageSize,
  status,
  module,
  startDate,
  endDate,
  searchValue
) => {
  const authToken = getAuthToken();

  const headers = {
    Authorization: `Bearer ${authToken}`,
  };

  let apiUrl = `/api/mail-logs/logs?page=${page}&pageSize=${pageSize}&status=${status}&module=${module}`;

  if (startDate && endDate) {
    apiUrl += `&startDate=${startDate}&endDate=${endDate}`;
  }

  if (searchValue) {
    apiUrl += `&searchValue=${searchValue}`;
  }

  return new Promise((resolve, reject) => {
    axios
      .get(apiUrl, { headers })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};